module.exports = __webpack_public_path__ + "d61d09c6ff8b671acfa827fd035a3a1a.pdf";